export enum ProcedureCategoryEnum {
    Unknown = 0,
    Cleaning = 1,
    Prewash = 2,
    Operational = 3,
    Emergency = 4,
    Sampling = 5,
    Wallwash = 6,
    Charterer = 7
}

export const getProcedureCategoryName = (category: ProcedureCategoryEnum | number): string => {
    switch (category) {
        case ProcedureCategoryEnum.Unknown:
            return 'Unknown';
        case ProcedureCategoryEnum.Cleaning:
            return 'Cleaning';
        case ProcedureCategoryEnum.Prewash:
            return 'Prewash';
        case ProcedureCategoryEnum.Operational:
            return 'Operational';
        case ProcedureCategoryEnum.Emergency:
            return 'Emergency';
        case ProcedureCategoryEnum.Sampling:
            return 'Sampling';
        case ProcedureCategoryEnum.Wallwash:
            return 'Wallwash';
        case ProcedureCategoryEnum.Charterer:
            return 'Charterer';
        default:
            return 'Unknown';
    }
};
